import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import TailoringHeader from './components/TailoringHeader';
import TailoringForm from './components/TailoringForm';

const TailoringPage = () => {
  return (
    <div className="min-h-screen bg-primary">
      <Navbar />
      <main className="pt-24">
        <TailoringHeader />
        <TailoringForm />
      </main>
      <Footer />
    </div>
  );
};

export default TailoringPage;